import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconSpendingPath = 'M6.36819327,4.99862492 L6.99999996,4.99999996 L18,4.99999996 L18,6.99999997 L6.44491979,6.99858644 C6.27201149,6.99996652 6.14795964,7.00442556 6.05775546,7.01224413 L5.99999996,7.01799997 L5.99999996,23 C5.99999996,23.5128359 6.38604016,23.9355072 6.88337884,23.9932723 L6.99999996,24 L22,24 C22.5128359,24 22.9355072,23.6139598 22.9932723,23.1166212 L23,23 L23,12 L25,12 L25,23 C25,24.5976809 23.7510801,25.9036609 22.1762728,25.9949073 L22,26 L6.99999996,26 C5.40231908,26 4.09633908,24.7510801 4.00509265,23.1762728 L3.99999996,23 L3.99999996,6.99999997 C3.99999996,6.12880095 4.40001622,5.47775727 5.13897642,5.18589365 C5.50087453,5.04295646 5.7847307,5.00402759 6.36819327,4.99862492 Z M23.5,2.99999995 C25.4329967,2.99999995 27,4.56700334 27,6.49999995 C27,8.4329966 25.4329967,9.99999995 23.5,9.99999995 C22.9868354,9.99999995 22.4994652,9.88956131 22.0603603,9.69115506 L18.6776645,14.6641659 L16.777,12.362 L13.5148347,17.1550702 L11.062,13.68 L8.79041503,16.6125717 L7.20958492,15.3874283 L11.1375296,10.3191126 L13.485,13.645 L16.6228494,9.03645625 L18.522,11.336 L20.5396872,8.36807803 C20.1978575,7.82752098 20,7.18686652 20,6.49999995 C20,4.56700334 21.5670034,2.99999995 23.5,2.99999995 Z M23.5,4.99999996 C22.6715729,4.99999996 22,5.67157284 22,6.49999996 C22,7.3284271 22.6715729,7.99999996 23.5,7.99999996 C24.3284272,7.99999996 25,7.3284271 25,6.49999996 C25,5.67157284 24.3284272,4.99999996 23.5,4.99999996 Z';
var NavigationIconSpendingActivePath = 'M6.7996227,4.99988246 L6.99999997,4.99999996 L19.3,4.99999996 C19.1044343,5.47604477 19.002572,5.98535641 19,6.49999997 C18.9662671,7.49632919 19.3254092,8.46601289 20,9.19999998 L20,9.19999998 L18.5,11.3 L16.6,8.99999998 L13.5,13.6 L11.1,10.3 L7.19999997,15.4 L8.79999998,16.6 L11,13.7 L13.5,17.1 L16.8,12.3 L18.7,14.7 L21.5,10.5 C22.120253,10.815832 22.8040911,10.9867915 23.5,11 C24.0146436,10.997428 24.5239552,10.8955657 25,10.7 L25,10.7 L25.0001175,23.2003773 C24.975252,23.9324396 24.6738383,24.6309548 24.1523966,25.1523966 C23.583551,25.7212421 22.8039734,26.028236 22,26 L6.7996227,26.0001175 C6.0675604,25.975252 5.36904518,25.6738383 4.84760344,25.1523966 C4.27875791,24.583551 3.97176397,23.8039734 3.99999996,23 L3.99988245,7.79962271 C4.02474804,7.0675604 4.32616171,6.36904518 4.84760344,5.84760344 C5.41644897,5.27875791 6.19602659,4.97176397 6.99999997,4.99999996 Z M23.5,3.99999996 C24.8807119,3.99999996 26,5.11928809 26,6.49999996 C26,7.16304119 25.7366079,7.79892598 25.267767,8.26776693 C24.798926,8.73660787 24.1630413,8.99999996 23.5,8.99999996 C23.1864431,9.02946799 22.8715652,8.95949511 22.6,8.79999998 C21.9796306,8.56910034 21.4761574,8.10158952 21.2,7.49999996 C21.0947992,7.17554526 21.0276818,6.83995848 21,6.49999996 C21,5.11928809 22.1192882,3.99999996 23.5,3.99999996 Z';
var NavigationIcon = baseIcon('NavigationIconSpending', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconSpendingActivePath : NavigationIconSpendingPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconSpending = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconSpending',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconSpending.displayName = 'NavigationIconSpending';
export default NavigationIconSpending;
//# sourceMappingURL=index.js.map